module.exports = __webpack_public_path__ + "img/advantage1.40ce672c.png";